module.exports = __webpack_public_path__ + "static/img/dolphinscheduler_logo.1642151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/dolphinscheduler_logo.png
// module id = 2oC3
// module chunks = 2